import Pendentes from '../screens/Pendentes';

const route = [
  {
    path: '/pendentes',
    main: Pendentes,
  },
];

export default route;
